export const customModdle = {
  'name': 'Pathways',
  'uri': 'http://philips.com/schema/bpmn/pathways',
  'prefix': 'pw',
  'xml': {
    'tagAlias': 'lowerCase'
  },
  'types': [
    {
      'name': 'NodeDetails',
      'superClass': ['Element'],
      'properties': [
        {
          'name': 'complicated',
          'isAttr': true,
          'type': 'boolean'
        },
        {
          'name': 'fields',
          'isMany': true,
          'type': 'Field'
        },
        {
          'name': 'questions',
          'isMany': true,
          'type': 'Question'
        },
        {
          'name': 'nodeType',
          'isAttr': true,
          'type': 'Integer'
        },
        {
          'name': 'hasPrimaryTreatment',
          'isAttr': true,
          'type': 'boolean'
        },
      ]
    },
    {
      'name': 'Field',
      'properties': [
        {
          'name': 'key',
          'isAttr': true,
          'type': 'String'
        },
        {
          'name': 'type',
          'isAttr': true,
          'type': 'String'
        },
        {
          'name': 'value',
          'isBody': true,
          'type': 'String'
        }
      ]
    },
    {
      'name': 'GuideBox',
      'superClass': ['Element'],
      'properties': [
        {
          'name': 'automatically',
          'isAttr': true,
          'type': 'boolean'
        }
      ]
    },
    {
      'name': 'Question',
      'properties': [
        {
          'name': 'key',
          'isAttr': true,
          'type': 'String'
        }
      ]
    },
    {
      'name': 'TrackingChange',
      'superClass': ['Element'],
      'properties': [
        {
          'name': 'type',
          'isAttr': true,
          'type': 'String'
        }
      ]
    },
  ],
  'emumerations': [],
  'associations': []
};
